import React from "react";
import styled from "styled-components";

const ComponentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	padding: 0.5rem 0.75rem;
	border-radius: 8px;
	min-width: 0;
`;

const Heading = styled.h2`
	font-size: 0.75rem;
	font-weight: 600;
	color: #6b7280;
	text-transform: uppercase;
	letter-spacing: 0.03em;
`;

const Value = styled.div`
	font-size: 0.875rem;
	font-weight: 600;
	color: #000;
	word-break: break-word;
`;

const Container = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
	align-items: center;
	gap: 0.5rem;
	padding: 0.75rem;
	background: ${({ isErrored }) => (isErrored ? "rgba(244, 66, 54, 0.2)" : "#f3f4f6")};
	border-radius: 0.5rem;
`;

const ContentComponent = ({ title, value, key }) => {
	return (
		<ComponentWrapper key={key}>
			<Heading>{title}</Heading>
			<Value>{value ?? "-"}</Value>
		</ComponentWrapper>
	);
};

const ContentContainer = ({ children, key, isErrored = false }) => {
	return (
		<Container isErrored={isErrored} key={key}>
			{children}
		</Container>
	);
};

export { ContentComponent, ContentContainer };
